import { searchActionTypes as actionTypes } from '../ActionTypes/searchActionTypes'

export const initialState = {
    searchInput: "",
    searchResult: null,
}

export default function SearchReducer(state = initialState, action) {

    let newState;

    switch(action.type) {

        case actionTypes.SEARCH_CUSTOMER_RESULT:
            newState = { searchInput: action.json.input, searchResult: action.json.data }
            break;

        case actionTypes.EMPTY_SEARCH_RESULTS:
            newState = { searchInput: "", searchResult: null }
            break;
            
        case actionTypes.SEARCH_LOADING:
            newState = {isSearching: action.json}
            break;

        default:
            return state
    }

    return Object.assign({}, state, newState)
}